import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  DateField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  DeleteButton,
  Filter,
  SearchInput,
  Pagination,
} from 'react-admin';

const FeedbackFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q[email_cont]" alwaysOn />
    <SearchInput source="q[title_cont]" />
  </Filter>
);

export const FeedbackList = (props) => (
  <List {...props} filters={<FeedbackFilter />} perPage={10}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <EmailField source="email" />
      <TextField source="name" />
      <TextField source="subject" />
      <TextField
        source="message"
        sx={{
          minWidth: 500,
          maxWidth: 600,
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          display: '-webkit-box',
          WebkitLineClamp: 16,
          WebkitBoxOrient: 'vertical'
        }}
      />
      <DateField source="created_at" />
      <DateField source="updated_at" />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const FeedbackEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="title" />
      <TextInput source="content" multiline />
      <TextInput source="email" />
      <TextInput source="name" />
    </SimpleForm>
  </Edit>
);

export const FeedbackCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="title" />
      <TextInput source="content" multiline />
      <TextInput source="email" />
      <TextInput source="name" />
    </SimpleForm>
  </Create>
);
